import { render, staticRenderFns } from "./HostingSummaryCardSkeleton.vue?vue&type=template&id=1991447b&scoped=true"
import script from "./HostingSummaryCardSkeleton.vue?vue&type=script&lang=js"
export * from "./HostingSummaryCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HostingSummaryCardSkeleton.vue?vue&type=style&index=0&id=1991447b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991447b",
  null
  
)

export default component.exports